import { configureStore, Middleware } from "@reduxjs/toolkit";
import snapshotReducer from "./snapshot/snapshotSlice";
import assetsSlice from "./assets/assetsSlice";
import { logger } from "../lib/logger";
import { ErrorCodes } from "../lib/errorCodes";

const rejectedActionsMiddleware: Middleware = () => (next) => (action) => {
  const result = next(action);
  if (typeof action === "object" && action !== null && "type" in action) {
    const typedAction = action as { type: string; error?: { message?: string }; payload?: unknown };
    if (typedAction.type.endsWith("/rejected")) {
      logger.error("redux", ErrorCodes.REDUX_001, typedAction.type, undefined, {
        errorMessage: typedAction.error?.message,
        payload: typedAction.payload,
      });
    }
  }
  return result;
};

export const store = configureStore({
  reducer: {
    snapshot: snapshotReducer,
    assets: assetsSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(rejectedActionsMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
